import Vue from 'vue';
import { AxiosResponse } from 'axios';

// import { CustomData } from './types';

// Пример кастомного сервиса
export const setDefaultSections = async ({commit, rootState}: any) => { 
  const response:AxiosResponse = await Vue.axios.put(`api/application/createDefaultSections`)
  commit('common/SET_ITEMS', {
    state: rootState.application,
    data: [response.data.result]
  }, {root: true}) // обновляем данные о приложении
  return [response.data.result]
} 